export default {
  width: 32,
  height: 24,
  svg: `
    <path fill-rule="evenodd" d="M2.293 2.293A1 1 0 0 1 3 2h26a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 .293-.707ZM3 0a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3Zm22.155 3.802.547.837a7.976 7.976 0 0 1 0 8.722l-.547.837-1.675-1.093.547-.838a5.976 5.976 0 0 0 0-6.534l-.547-.837 1.675-1.094Zm-3.672 1.935.632.776a3.94 3.94 0 0 1 0 4.974l-.632.776L19.933 11l.63-.775a1.94 1.94 0 0 0 0-2.45L19.934 7l1.55-1.263ZM5 17h14v2H5v-2Zm17 0h-1v2h6v-2h-5ZM5 5h7v6H5V5Zm2 2v2h3V7H7Zm12 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" clip-rule="evenodd"/>
  `
}
